import React from 'react';

import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

const ConfirmModal = (props) => {
  const {
    show,
    title,
    children,
    onClickYes,
    onClickNo,
    labelYes,
    labelNo,
    variant_yes,
    variant_no,
    ...modalProps
  } = props;

  return (
    <Modal show={show} onHide={onClickNo} {...modalProps}>
      <Modal.Header>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {children}
      </Modal.Body>
      <Modal.Footer>
        <Button variant={variant_yes} onClick={onClickYes}>
          {labelYes}
        </Button>
        <Button variant={variant_no} onClick={onClickNo}>
          {labelNo}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

ConfirmModal.defaultProps = {
  labelYes: 'Yes',
  labelNo: 'No',
  variant_yes: 'primary',
  variant_no: 'secondary',
};

export default ConfirmModal;
